import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import logo64 from '../../../assets/images/logo/logo64.png';
import logo128 from '../../../assets/images/logo/logo128.png';
import logo256 from '../../../assets/images/logo/logo256.png';
import logo512 from '../../../assets/images/logo/logo512.png';
import './appLogo.scss';

const logoSrcSet = [
  `${logo64} 64w`,
  `${logo128} 128w`,
  `${logo256} 256w`,
  `${logo512} 600w`,
].join(', ');

const AppLogo = ({ className = '', size = 64, linked = false }) => {
  const image = (
    <img
      className={`app-logo ${className}`.trim()}
      src={logo128}
      srcSet={logoSrcSet}
      sizes={`${size}px`}
      width={size}
      height={size}
      alt="Student Portfolio Builder"
    />
  );

  return linked ? (
    <Link className="app-logo-link" to="/dashboard" aria-label="Student Portfolio Builder dashboard">
      {image}
    </Link>
  ) : image;
};

AppLogo.propTypes = {
  className: PropTypes.string,
  size: PropTypes.number,
  linked: PropTypes.bool,
};

export default AppLogo;
